import type { Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function setAppSocket(s: Socket | null) {
  socket = s;
}

export function getAppSocket(): Socket | null {
  return socket;
}
